var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WujieVue',{attrs:{"width":"100%","height":"100%","name":_vm.flowUrl,"url":_vm.flowUrl,"plugins":_vm.plugins}})}
var staticRenderFns = []

export { render, staticRenderFns }